import { render, staticRenderFns } from "./CopyModal.vue?vue&type=template&id=0b115c22&"
import script from "./CopyModal.vue?vue&type=script&lang=js&"
export * from "./CopyModal.vue?vue&type=script&lang=js&"
import style0 from "./CopyModal.vue?vue&type=style&index=0&id=0b115c22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports